module.exports = __webpack_public_path__ + "static/media/java.e4a2b43b.svg";